import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  Text,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from "@chakra-ui/react";
import * as React from "react";
import { useMutation } from "react-query";
import { addPatient } from "../../../../api";

interface NewPatientPopupProps {
  onPatientAdded?: () => void;
}

export const NewPatientPopup = ({ onPatientAdded }: NewPatientPopupProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [externalId, setExternalId] = React.useState("");
  const [username, setUsername] = React.useState("");
  const [error, setError] = React.useState<string | null>(null);

  const initialRef = React.useRef(null);

  const { mutate, isLoading } = useMutation(addPatient, {
    onSuccess: () => {
      onClose();
      if (onPatientAdded) onPatientAdded();
    },
    onError: (err) => {
      setError("Sorry, new client could not be added.");
    },
  });

  const renderError = () => {
    if (error) {
      return (
        <Text color="red" mt={4}>
          {error}
        </Text>
      );
    }
    return null;
  };

  const handleAddClick = async () => {
    setError(null);

    if (!externalId) {
      setError("Please enter a unique external ID");
      return;
    }

    mutate({ externalId, username });
  };

  return (
    <>
      <Button onClick={onOpen}>New Client</Button>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Add Client</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>External ID</FormLabel>
              <Input
                ref={initialRef}
                value={externalId}
                onChange={(e) => setExternalId(e.target.value)}
              />
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>Username</FormLabel>
              <Input
                placeholder="(optional)"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </FormControl>
            {renderError()}
          </ModalBody>

          <ModalFooter>
            <Button
              colorScheme="blue"
              mr={3}
              onClick={handleAddClick}
              isLoading={isLoading}
            >
              Add
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
